import { Tooltip, Typography } from "@mui/material";
import { styled } from "@mui/system";
import { Banner, Button, Card, InfoIcon } from "@volt_developers/components";
import { useTranslation } from "react-i18next";

import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import { getRGBA } from "utils/getRGBA";

import { DisabledTooltipAnchor } from "../DisabledTooltipAnchor";

export interface NotificationTestErrorBannerCardItemProps {
  handleClick(): void;
  isDisabled: boolean;
  isOpen: boolean;
}

export function NotificationTestErrorBannerCardItem({
  isDisabled,
  isOpen,
  handleClick,
}: NotificationTestErrorBannerCardItemProps) {
  const { t } = useTranslation("common");

  if (!isOpen) {
    return null;
  }

  return (
    <StyledCardItem sm={12} sx={{ pt: 0, pb: 1 }}>
      <Banner.Wrapper
        variant="failure"
        sx={(theme) => ({
          backgroundColor: getRGBA(theme.palette.failure.main, 0.1),
          color: theme.palette.failure.main,
        })}
      >
        <Banner.Content>
          <Banner.IconWrapper>
            <InfoIcon color="error" />
          </Banner.IconWrapper>
          <Typography variant="small">
            {t(COMMON_TRANSLATION_KEYS.theTestNotificationHasFailed)}
          </Typography>
        </Banner.Content>
        <Tooltip
          placement="top"
          title={
            isDisabled
              ? t(COMMON_TRANSLATION_KEYS.noResponseHasBeenReceived)
              : ""
          }
          arrow
        >
          <DisabledTooltipAnchor>
            <Button
              color="danger"
              disabled={isDisabled}
              variant="outlined"
              onClick={handleClick}
            >
              {t(COMMON_TRANSLATION_KEYS.viewError)}
            </Button>
          </DisabledTooltipAnchor>
        </Tooltip>
      </Banner.Wrapper>
    </StyledCardItem>
  );
}

const StyledCardItem = styled(Card.Item)(({ theme }) => ({
  marginLeft: theme.spacing(-2.5),
  marginRight: theme.spacing(-2.5),
  minWidth: `calc(100% + ${theme.spacing(5)})`,
}));
